import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { edcUrls } from "../../URL/ApplicationUrls";
import { Edc } from "../Edc";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { MdmApiError } from "../../Errors/MdmApiError";

export const useAddEdc = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (edc: Edc) => {
      return axios.post<number>(edcUrls.addEdc.apiUrl, edc);
    },
    onSuccess: async (response: AxiosResponse<number>) => {
      navigate(edcUrls.mutateEdc(response.data).uiPath);
      toast.success(`The EDC with the Id ${response.data} has been created`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
